import { create } from 'zustand';

export type OfficeTriggerSource = 'tab_click' | 'auto_frequency_rule';

export interface DrawerStore {
  drawerOpen: boolean;
  setDrawerOpen: (isOpen: boolean) => void;

  selectedMenu: string;
  setSelectedMenu: (
    menu:
      | 'PATIENT_DATA'
      | 'MODELS'
      | 'DRUG_INTERACTIONS'
      | 'PERSONAL_SETTINGS'
      | 'POLICY'
      | 'HISTORY'
      | 'OFFICE'
      | 'PRESCRIBER_DATA'
      | 'HELP'
      | 'RECURRENCES'
      | 'SNCR_NUMBERING'
      | 'News'
      | ''
  ) => void;

  officeTriggerSource: OfficeTriggerSource;
  setOfficeTriggerSource: (source: OfficeTriggerSource) => void;

  openOfficeAutomatically: () => void;
}

export const useDrawerStore = create<DrawerStore>()((set, get) => ({
  drawerOpen: false,
  setDrawerOpen: (isOpen: boolean) => {
    set((prev) => {
      return {
        ...prev,
        drawerOpen: isOpen,
      };
    });
  },
  selectedMenu: '',
  setSelectedMenu: (menu) => {
    set((prev) => {
      return {
        ...prev,
        selectedMenu: menu,
      };
    });
  },
  officeTriggerSource: 'tab_click',
  setOfficeTriggerSource: (source: OfficeTriggerSource) => {
    set({ officeTriggerSource: source });
  },
  openOfficeAutomatically: () => {
    set({
      officeTriggerSource: 'auto_frequency_rule',
      selectedMenu: 'OFFICE',
      drawerOpen: true,
    });
  },
}));
